import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { ThreadService } from '@app/shared/services/thread/thread.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-broadcast-message',
  templateUrl: './dialog-broadcast-message.component.html',
  styleUrls: ['./dialog-broadcast-message.component.scss'],
})
export class DialogBroadcastMessageComponent implements OnInit {
  cannedResponses: BehaviorSubject<any> = new BehaviorSubject([]);
  origCannedResponses: any;
  selectedCr: any;
  stage = 1;

  constructor(
    public dialogRef: MatDialogRef<DialogBroadcastMessageComponent>,
    private threadService: ThreadService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public dialogData: { threads: any[] }
  ) { }

  ngOnInit() {
    this.getCannedResponses();
    this.setAllThreadsToWaiting();
  }

  countOfSentMessages() {
    return this.dialogData.threads.filter((thread) => thread.send_status === 'Sent').length;
  }

  getCannedResponses() {
    this.threadService.getCanned().subscribe((res) => {
      this.origCannedResponses = res.data;
      this.cannedResponses.next(res.data);
    });
  }

  setAllThreadsToWaiting() {
    this.dialogData.threads.forEach((thread, index) => {
      this.dialogData.threads[index].send_status = 'Waiting';
    });
  }

  searchUpdated(searchString) {
    if (typeof searchString === 'string') {
      this.cannedResponses.next(
        this.origCannedResponses.filter((cr) => cr.name.toLowerCase().includes(searchString.toLowerCase()))
      );
    }
  }

  sendMessages() {
    this.stage = 2;

    this.dialogData.threads.forEach((thread, index) => {
      this.dialogData.threads[index].send_status = 'Preparing';

      // prepare the message
      this.threadService.prepareCannedResponse(thread.uuid, this.selectedCr.id).subscribe((res) => {
        if (res.error) {
          this.dialogData.threads[index].send_status = 'Failed';
        } else {
          this.dialogData.threads[index].prepared_mesesage = res;

          this.dialogData.threads[index].send_status = 'Sending';

          this.threadService
            .sendMessage(thread.uuid, this.dialogData.threads[index].prepared_mesesage)
            .subscribe((res) => {
              if (res.error) {
                this.dialogData.threads[index].send_status = 'Failed';
              } else {
                this.dialogData.threads[index].send_status = 'Sent';
              }
            });
        }
      });
    });
  }

  refreshInbox() {
    this.dialogRef.close();
    this.router.navigate(['/inbox']);
  }

  autocompleteDisplayFn(cr): string {
    return cr && cr.name ? cr.name : '';
  }
}
